import { render } from "./HandOver.vue?vue&type=template&id=4e20b2f8"
import script from "./HandOver.vue?vue&type=script&lang=js"
export * from "./HandOver.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__